var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { objEq, } from "../utilities/aux";
let AttachmentsElement = class AttachmentsElement extends Vue {
    constructor() {
        super(...arguments);
        this.errorFileNames = [];
        this.newValues = [];
        this.waitOnFiles = 0;
    }
    attachmentsChanged() {
        return [
            ...this.oldValues.attachments,
            ...this.newValues,
        ];
    }
    reset() {
        this.errorFileNames = [];
        this.waitOnFiles = 0;
        this.newValues = [];
    }
    handleInput(event) {
        this.reset();
        if (event.target.files === undefined || event.target.files === null) {
            throw Error("Missing file");
        }
        const newFiles = [];
        this.waitOnFiles = event.target.files.length;
        for (const file of event.target.files) {
            if (file.size > this.attachmentMaxFileSize) {
                this.errorFileNames.push(file.name);
            }
        }
        if (this.errorFileNames.length !== 0) {
            this.waitOnFiles = 0;
            return;
        }
        for (const file of event.target.files) {
            new Response(file)
                .arrayBuffer()
                .then(ab => {
                const uint8Array = new Uint8Array(ab);
                const data = uint8Array.reduce((acc, i) => acc + String.fromCharCode.apply(null, [i]), "");
                const base64String = btoa(data);
                newFiles.push({
                    name: file.name,
                    data: base64String,
                });
                --this.waitOnFiles;
                if (this.waitOnFiles === 0) {
                    this.newValues = newFiles;
                    this.attachmentsChanged();
                }
            })
                .catch(() => {
                throw Error("Error adding attachment.");
            });
        }
    }
    handleDeletion(attachment) {
        {
            const f = this.newValues.findIndex(n => objEq(n, attachment));
            if (f !== -1) {
                this.newValues.splice(f, 1);
                return;
            }
        }
        const f = this.oldValues.attachments.findIndex(n => objEq(n, attachment));
        if (f === -1) {
            throw Error("Removing failed");
        }
        this.oldValues.attachments.splice(f, 1);
    }
    get elementKey() { return "attachments"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get attachmentMaxFileSize() {
        return this.networkBroker.configuration.attachmentMaxFileSize;
    }
    created() { this.oldValues = this.value; }
    onValueChanged(val, _oldVal) {
        this.reset();
        this.oldValues = val;
    }
};
__decorate([
    Prop({ required: true })
], AttachmentsElement.prototype, "value", void 0);
__decorate([
    Inject()
], AttachmentsElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], AttachmentsElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], AttachmentsElement.prototype, "attachmentsChanged", null);
__decorate([
    Watch("value")
], AttachmentsElement.prototype, "onValueChanged", null);
AttachmentsElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "AttachmentsElement",
    })
], AttachmentsElement);
export default AttachmentsElement;
